<template>
<div class="page-container">
  <div class="card">
    <page-title :title="title"></page-title>
    <el-row class="search-container" :gutter="20">
      <el-col :xs="24" :sm="12" :md="8">
        <el-card shadow="hover">
          <div class="config-card-placeholder" @click="toSystemConfig">
            <svg-icon icon="system"></svg-icon>
            <span>{{ $t('系统配置') }}</span>
          </div>
          <div style="float: right; padding-right: 1rem;">
            <el-button type="text" class="button" @click="toSystemConfig">{{ $t('点击进入系统配置') }}</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import PageTitle from '../../../components/PageTitle/index'

export default {
  name: 'ConfigIndex',

  components: { PageTitle },

  data () {
    return {
      // 页面标题
      title: ''
    }
  },

  mounted () {
    // 赋值当前页面内容
    this.title = this.$route.meta.title
  },

  methods: {
    toSystemConfig () {
      this.$router.push('/config-content/system')
    },
    toAboutMe () {
      this.$router.push('/config-content/about-me')
    }
  }
}
</script>

<style lang="scss" scoped>
.config-card-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 180px;
  color: #409eff;
  cursor: pointer;

  .svg-icon {
    font-size: 60px;
  }

  span {
    margin-top: 12px;
    color: #606266;
    font-size: 16px;
  }
}
.card-image {
  display: flex;
  justify-content: center;
  height: 15.625rem;
  cursor: pointer;
}
.el-card {
  border-radius: 0.75rem;
}
</style>
